var React = require('react');

function ArrowRightBlack (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(5.899 -0.361) rotate(180)"},React.createElement("path",{"d":"M-5.33,5.258A.652.652,0,0,1-5.69,5.1l-4.562-3.91a.652.652,0,0,1-.28-.635A.652.652,0,0,1-10.081.03.652.652,0,0,1-9.41.207l4.141,3.55L-1.129.207A.652.652,0,0,1-.458.03.652.652,0,0,1-.007.557a.652.652,0,0,1-.28.635L-4.848,5.1a.652.652,0,0,1-.482.156Z","transform":"translate(5.899 -0.361) rotate(90)","fill":"currentColor"})));
}

ArrowRightBlack.defaultProps = {"className":"icon-svg","viewBox":"0 0 5.26 10.539"};

module.exports = ArrowRightBlack;

ArrowRightBlack.default = ArrowRightBlack;
